import { SVGFC } from '@repo/toolkit/types'

const IdPhotoIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_15969_25977)">
        <path
          d="M17.0194 9.44531H20.654C20.9753 9.44531 21.2835 9.57296 21.5107 9.80016C21.7379 10.0274 21.8655 10.3355 21.8655 10.6569V23.5799C21.8655 23.9012 21.7379 24.2094 21.5107 24.4366C21.2835 24.6638 20.9753 24.7915 20.654 24.7915H9.3463C9.02498 24.7915 8.71682 24.6638 8.48962 24.4366C8.26241 24.2094 8.13477 23.9012 8.13477 23.5799V10.6569C8.13477 10.3355 8.26241 10.0274 8.48962 9.80016C8.71682 9.57296 9.02498 9.44531 9.3463 9.44531H12.9809"
          stroke={color}
          strokeWidth="0.807692"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.0189 8.23407V11.061C17.0189 11.2752 16.9338 11.4807 16.7824 11.6321C16.6309 11.7836 16.4255 11.8687 16.2112 11.8687H13.7882C13.5739 11.8687 13.3685 11.7836 13.217 11.6321C13.0656 11.4807 12.9805 11.2752 12.9805 11.061V8.23407C12.9805 7.69854 13.1932 7.18494 13.5719 6.80626C13.9506 6.42758 14.4642 6.21484 14.9997 6.21484C15.2649 6.21484 15.5274 6.26707 15.7724 6.36855C16.0174 6.47002 16.24 6.61876 16.4275 6.80626C16.615 6.99377 16.7638 7.21636 16.8652 7.46135C16.9667 7.70633 17.0189 7.96891 17.0189 8.23407Z"
          stroke={color}
          strokeWidth="0.807692"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9995 8.63972C15.2226 8.63972 15.4034 8.45892 15.4034 8.23588C15.4034 8.01284 15.2226 7.83203 14.9995 7.83203C14.7765 7.83203 14.5957 8.01284 14.5957 8.23588C14.5957 8.45892 14.7765 8.63972 14.9995 8.63972Z"
          stroke={color}
          strokeWidth="0.807692"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0002 17.5237C15.8923 17.5237 16.6155 16.8005 16.6155 15.9084C16.6155 15.0162 15.8923 14.293 15.0002 14.293C14.108 14.293 13.3848 15.0162 13.3848 15.9084C13.3848 16.8005 14.108 17.5237 15.0002 17.5237Z"
          stroke={color}
          strokeWidth="0.807692"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9995 18.7344C14.0901 18.7753 13.2073 19.0538 12.4391 19.5421C12.2331 19.6738 12.0637 19.8554 11.9466 20.07C11.8294 20.2846 11.7682 20.5253 11.7687 20.7698V21.0282C11.7598 21.1598 11.8032 21.2896 11.8894 21.3894C11.9756 21.4892 12.0976 21.551 12.2291 21.5613H17.7699C17.9013 21.551 18.0234 21.4892 18.1096 21.3894C18.1958 21.2896 18.2392 21.1598 18.2303 21.0282V20.7698C18.2308 20.5253 18.1696 20.2846 18.0524 20.07C17.9352 19.8554 17.7658 19.6738 17.5599 19.5421C16.7916 19.0538 15.9089 18.7753 14.9995 18.7344Z"
          stroke={color}
          strokeWidth="0.807692"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_15969_25977">
          <rect
            width="19.3846"
            height="19.3846"
            fill="white"
            transform="translate(5.30859 5.80859)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IdPhotoIcon
